import { AppBar, Box, IconButton, Toolbar } from '@mui/material'
import React from 'react'
import { MenuOutlined } from '@mui/icons-material'
import TenantBreadCrumbs from './TenantBreadCrumbs'
import TenantMenu from './TenantMenu'

const drawerWidth = 250

const HeaderTenant = ({ handleDrawerToggle }) => {
  return (
    <Box sx={{ mb: 10 }}>
      <AppBar
        position={'fixed'}
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          bgcolor: 'white',
          boxShadow: 'rgb(32 32 32 / 6%) 0px 8px 16px;',
        }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <IconButton
            color="primary"
            aria-label="Abrir Barra"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuOutlined/>
          </IconButton>
          <TenantBreadCrumbs/>
          <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
            <TenantMenu/>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default HeaderTenant
